// 口コミ生成ツール (issue #2070) のアンケート選択肢 SSOT。
// company（屋根業者管理: 質問項目カスタマイズ）と customer（施主アンケート）の両アプリで参照する。
// 移植元: tmp/issue-2070/constants.ts（24 / 13 / 19 の選択肢）
// 設計 SSOT: doc/architecture/review-generator.md

/** 工事内容（最大 3 選択） */
export const WORK_TYPE_OPTIONS = [
  '屋根修理',
  '瓦の葺き替え',
  '屋根全体の葺き替え',
  '屋根のカバー工法',
  '屋根塗装',
  '屋根の点検',
  '雨漏り修理',
  '漆喰の塗り直し',
  '太陽光パネル取付',
  '雪止め金具の設置',
  '天窓の修理・交換',
  '雨どいの修理',
  '雨どいの交換',
  '外壁塗装',
  '外壁補修',
  'サイディングの張り替え',
  'ベランダ防水工事',
  '屋上防水工事',
  'キッチンリフォーム',
  'お風呂リフォーム',
  '洗面台リフォーム',
  'トイレリフォーム',
  '内装リフォーム',
  'エクステリア工事',
] as const

/** 当社を選んだ理由（最大 2 選択） */
export const REASON_OPTIONS = [
  '地域密着で信頼できると感じたから',
  '見積りの内容が詳細で分かりやすかったから',
  '費用の内訳が明確で納得できたから',
  '見積り金額が適正で納得できたから',
  '説明が丁寧で安心できたから',
  '担当者の対応が誠実で信頼できたから',
  '施工実績が豊富で安心できたから',
  'Googleマップの口コミ評価が良かったから',
  'ドローン点検で細かい部分まで見てもらえたから',
  '補助金のサポートがあったから',
  '助成金のサポートがあったから',
  '対応が迅速でスピード感があったから',
  'その他',
] as const

/** 特に印象に残った点（複数選択） */
export const IMPRESSION_OPTIONS = [
  '仕上がりがきれいで満足できた',
  '施工が丁寧で細部まで配慮があった',
  '工期が予定通りに完了した',
  '進捗報告がこまめで安心できた',
  '説明がわかりやすく理解できた',
  '価格と品質のバランスが良かった',
  '生活の安心感が向上した',
  '雨漏りの不安がなくなった',
  '近隣への配慮がしっかりしていた',
  '安全面に配慮されていた',
  '職人さんの対応やマナーが良かった',
  '工事後の清掃が丁寧で安心できた',
  'アフターサポートが充実していた',
  '保証内容が安心できた',
  '家族や近所の方から褒められた',
  '細かな要望にも柔軟に対応してくれた',
  '引き渡し時の説明が丁寧だった',
  '「次回もお願いしたい」と思えた',
  'その他',
] as const

/** 選択上限（サーバ側でも再検証する） */
export const WORK_TYPE_MAX = 3
export const REASON_MAX = 2

/** セクション ID。proto ReviewQuestionConfig の visibility/order の key prefix と一致させる */
export type ReviewSectionId = 'workType' | 'reason' | 'impression'

export interface ReviewQuestionSection {
  id: ReviewSectionId
  label: string
  options: readonly string[]
  /** 選択上限（undefined は無制限） */
  max?: number
}

export const QUESTION_SECTIONS: readonly ReviewQuestionSection[] = [
  { id: 'workType', label: '工事内容', options: WORK_TYPE_OPTIONS, max: WORK_TYPE_MAX },
  { id: 'reason', label: '当社を選んだ理由', options: REASON_OPTIONS, max: REASON_MAX },
  { id: 'impression', label: '特に印象に残った点', options: IMPRESSION_OPTIONS },
] as const

/** visibility / order の map key を組み立てる（例 "workType:屋根修理"） */
export const buildOptionKey = (sectionId: ReviewSectionId, option: string): string =>
  `${sectionId}:${option}`

/** 書き手の年代（任意・文体ヒント） */
export const AGE_GROUP_OPTIONS = [
  '10代',
  '20代',
  '30代',
  '40代',
  '50代',
  '60代',
  '70代以上',
] as const

/** 書き手の性別（任意・文体ヒント） */
export const GENDER_OPTIONS = ['男性', '女性', 'その他'] as const
